import { render, staticRenderFns } from "./Dormancy.vue?vue&type=template&id=14a2450f&scoped=true&"
import script from "./Dormancy.vue?vue&type=script&lang=js&"
export * from "./Dormancy.vue?vue&type=script&lang=js&"
import style0 from "./Dormancy.vue?vue&type=style&index=0&id=14a2450f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a2450f",
  null
  
)

export default component.exports